export const CONTACT_EMAIL = 'trnfinc@gmail.com';
export const ADDRESS = '3153 Ady Rd, Street, MD';
export const FACEBOOK_URL = 'https://www.facebook.com/therapeuticridingatnormandyfarm/';
